// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Match score pad — mockup layout, club brand accents, bottom tabs stay visible */

.cm-scorepad {
  --sp-home: var(--brand-primary, #0877bc);
  --sp-away: var(--brand-secondary, #c2410c);
  --sp-home-soft: rgba(8, 119, 188, 0.12);
  --sp-away-soft: rgba(194, 65, 12, 0.12);
  --sp-ink: #0f172a;
  --sp-muted: #64748b;
  --sp-line: rgba(15, 23, 42, 0.08);
  --sp-panel: #f1f5f9;
  --sp-card: #ffffff;
  --sp-ease: cubic-bezier(0.16, 1, 0.3, 1);
  --sp-display: "DIN Alternate", "Bahnschrift", "Roboto Condensed",
    "Arial Narrow", system-ui, sans-serif;
  --sp-safe-b: env(safe-area-inset-bottom, 0px);

  position: relative;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.35rem 0.7rem 0.55rem;
  overflow: hidden auto;
  -webkit-overflow-scrolling: touch;
  color: var(--sp-ink);
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
}

.cm-scorepad--dark {
  --sp-ink: #f1f5f9;
  --sp-muted: #94a3b8;
  --sp-line: rgba(248, 250, 252, 0.1);
  --sp-panel: #1e293b;
  --sp-card: #121a2b;
  background: linear-gradient(180deg, #0e1524 0%, #070b14 100%);
}

.cm-scorepad__head {
  position: relative;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.35rem;
  flex: 0 0 auto;
}

.cm-scorepad__record {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 2.55rem;
  border: 0;
  border-radius: 999px;
  background: #e11d48;
  color: #fff;
  font: inherit;
  font-size: 0.88rem;
  font-weight: 750;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.cm-scorepad__record:disabled {
  opacity: 0.55;
  cursor: wait;
}

.cm-scorepad__record.is-live {
  background: #111827;
  box-shadow: inset 0 0 0 2px #e11d48;
}

.cm-scorepad--dark .cm-scorepad__record.is-live {
  background: #1e293b;
}

.cm-scorepad__head-actions {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
}

.cm-scorepad__back,
.cm-scorepad__more,
.cm-scorepad__reset {
  width: 2.35rem;
  height: 2.35rem;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: var(--sp-ink);
  display: grid;
  place-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  flex-shrink: 0;
}

.cm-scorepad__reset {
  color: #e11d48;
  background: color-mix(in srgb, #e11d48 10%, transparent);
}

.cm-scorepad__reset:disabled {
  opacity: 0.4;
  pointer-events: none;
}

.cm-scorepad__title {
  min-width: 0;
  text-align: center;
}

.cm-scorepad__title strong {
  display: block;
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.cm-scorepad__title span {
  display: block;
  font-size: 0.68rem;
  font-weight: 650;
  color: var(--sp-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cm-scorepad__badge {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.1rem;
  padding: 0.35rem 0.55rem;
  border-radius: 12px;
  background: var(--sp-panel);
  border: 1px solid var(--sp-line);
}

.cm-scorepad__badge em {
  font-style: normal;
  font-size: 0.72rem;
  font-weight: 800;
}

.cm-scorepad__badge span {
  font-size: 0.62rem;
  font-weight: 650;
  color: var(--sp-muted);
  white-space: nowrap;
}

.cm-scorepad__menu {
  position: absolute;
  top: 2.7rem;
  right: 0;
  z-index: 8;
  min-width: 11rem;
  padding: 0.35rem;
  border-radius: 14px;
  border: 1px solid var(--sp-line);
  background: var(--sp-card);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.16);
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.cm-scorepad__menu button {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-height: 2.35rem;
  padding: 0.35rem 0.55rem;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--sp-ink);
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  text-align: left;
}

.cm-scorepad__menu button.is-danger {
  color: #e11d48;
}

.cm-scorepad__menu button:active {
  background: var(--sp-panel);
}

.cm-scorepad__cue {
  margin: 0;
  text-align: center;
  font-size: 0.82rem;
  font-weight: 800;
  padding: 0.4rem 0.6rem;
  border-radius: 12px;
  background: color-mix(in srgb, var(--sp-home) 16%, var(--sp-card));
  border: 1px solid color-mix(in srgb, var(--sp-home) 35%, transparent);
}

.cm-scorepad__board {
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0.35rem;
  overflow: hidden;
}

.cm-scorepad__card {
  position: relative;
  min-height: 0;
  max-height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  gap: 0.2rem;
  padding: 0.4rem 0.5rem 0.45rem;
  border-radius: 18px;
  border: 1px solid transparent;
  background: var(--sp-home-soft);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--sp-card-accent, var(--sp-home)) 18%, transparent);
  overflow: hidden;
  box-sizing: border-box;
}

.cm-scorepad__card--away {
  background: var(--sp-away-soft);
}

.cm-scorepad__card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.35rem;
  min-width: 0;
  min-height: 1.35rem;
}

.cm-scorepad__meta {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.2rem;
  min-width: 0;
}

.cm-scorepad__games {
  flex-shrink: 0;
  display: inline-flex;
  align-items: baseline;
  gap: 0.22rem;
  font-size: 0.65rem;
  font-weight: 700;
  color: var(--sp-muted);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.cm-scorepad__games strong {
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--sp-ink);
  letter-spacing: -0.03em;
}

.cm-scorepad__games em {
  font-style: normal;
  font-size: 0.58rem;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cm-scorepad__club-logo {
  width: 1.85rem !important;
  height: 1.85rem !important;
  max-width: 1.85rem;
  max-height: 1.85rem;
  border-radius: 8px !important;
  object-fit: contain !important;
  background: color-mix(in srgb, var(--sp-card) 80%, transparent);
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.12);
}

.cm-scorepad__club-logo.club-logo-mark--fallback {
  border-radius: 8px !important;
}

.cm-scorepad__club-logo .club-logo-mark__letter {
  font-size: 0.72rem;
}

.cm-scorepad__who-row {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex: 1 1 auto;
}

.cm-scorepad__who-block {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.06rem;
  flex: 1 1 auto;
}

.cm-scorepad__rank {
  display: flex;
  flex-direction: column;
  gap: 0.02rem;
  min-width: 0;
}

.cm-scorepad__rank-line {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.62rem;
  font-weight: 750;
  letter-spacing: 0.01em;
  line-height: 1.15;
  color: var(--sp-muted);
  font-variant-numeric: tabular-nums;
  text-transform: none;
}

.cm-scorepad__serve {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.22rem;
  padding: 0.14rem 0.42rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--sp-card-accent, var(--sp-home)) 18%, var(--sp-card));
  color: var(--sp-card-accent, var(--sp-home));
  font-size: 0.55rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
  line-height: 1;
}

.cm-scorepad__serve i {
  width: 0.35rem;
  height: 0.35rem;
  border-radius: 50%;
  background: currentColor;
}

.cm-scorepad__who {
  min-width: 0;
  font-size: clamp(0.7rem, 2.6vw, 0.85rem);
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-scorepad__score-wrap {
  min-height: 0;
  width: 100%;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.cm-scorepad__pts,
.cm-scorepad__pts-input {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  width: auto;
  min-width: 0;
  min-height: 0;
  max-width: 100%;
  max-height: 100%;
  text-align: center;
  font-family: var(--sp-display);
  font-size: 96px; /* JS fit overrides via inline style */
  font-weight: 800;
  letter-spacing: -0.04em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: var(--sp-ink);
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  appearance: none;
  -webkit-appearance: none;
}

.cm-scorepad__pts:not(.cm-scorepad__pts--read) {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  cursor: pointer;
}

.cm-scorepad__pts-num {
  display: block;
  line-height: 1;
  letter-spacing: -0.04em;
  font-weight: 800;
  font-family: inherit;
  font-variant-numeric: tabular-nums;
}

.cm-scorepad__pts:disabled,
.cm-scorepad__pts--read {
  cursor: default;
}

.cm-scorepad__pts--read {
  display: block;
  line-height: 1;
  max-width: 100%;
  max-height: 100%;
  pointer-events: none;
}

.cm-scorepad__pts:active:not(:disabled) {
  transform: scale(0.97);
}

.cm-scorepad__pts-input {
  outline: none;
  border-bottom: 3px solid color-mix(in srgb, var(--sp-card-accent, var(--sp-home)) 55%, transparent);
  max-width: 4.5ch;
  margin: 0 auto;
  caret-color: var(--sp-card-accent, var(--sp-home));
}

.cm-scorepad__ops {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 0.3rem;
  flex-shrink: 0;
  min-height: 2.4rem;
}

.cm-scorepad__ops.is-empty {
  visibility: hidden;
  pointer-events: none;
}

.cm-scorepad__plus,
.cm-scorepad__minus {
  min-height: 2.4rem;
  height: 2.4rem;
  padding: 0;
  border: 0;
  border-radius: 12px;
  display: grid;
  place-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  transition: transform 0.12s var(--sp-ease);
}

.cm-scorepad__plus svg,
.cm-scorepad__minus svg {
  width: 22px;
  height: 22px;
}

.cm-scorepad__plus:active,
.cm-scorepad__minus:active:not(:disabled) {
  transform: scale(0.96);
}

.cm-scorepad__plus:focus-visible,
.cm-scorepad__minus:focus-visible {
  outline: 2px solid var(--sp-ink);
  outline-offset: 2px;
}

.cm-scorepad__plus {
  background: var(--sp-card-accent, var(--sp-home));
  color: #fff;
  box-shadow: 0 5px 12px color-mix(in srgb, var(--sp-card-accent, var(--sp-home)) 32%, transparent);
}

.cm-scorepad__minus {
  background: var(--sp-panel);
  color: var(--sp-ink);
}

.cm-scorepad__minus:disabled {
  opacity: 0.35;
  pointer-events: none;
}

.cm-scorepad__banner {
  margin: 0;
  text-align: center;
  font-size: 0.85rem;
  font-weight: 800;
  padding: 0.45rem 0.65rem;
  border-radius: 12px;
  background: color-mix(in srgb, var(--sp-home) 14%, var(--sp-card));
}

.cm-scorepad__dock {
  /* Keep tags under the score — never let them paint over the big digits. */
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  flex: 0 0 auto;
  margin-top: auto;
  min-width: 0;
  padding-top: 0.2rem;
  background: linear-gradient(
    180deg,
    transparent 0%,
    color-mix(in srgb, var(--sp-card) 88%, transparent) 28%
  );
}

.cm-scorepad__dock .cm-outcome {
  flex: 0 0 auto;
  min-width: 0;
}

.cm-scorepad__dock .cm-outcome__btn {
  min-height: 2.45rem;
  padding: 0.22rem 0.12rem 0.26rem;
}

.cm-scorepad__dock .cm-outcome__text {
  font-size: 0.62rem;
}

.cm-scorepad__midrow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.45rem;
  align-items: center;
  flex: 0 0 auto;
}

.cm-scorepad__undo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 2.85rem;
  border: 0;
  border-radius: 16px;
  background: var(--sp-panel);
  color: var(--sp-ink);
  font-size: 0.9rem;
  font-weight: 750;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.cm-scorepad__undo:disabled {
  opacity: 0.4;
  pointer-events: none;
}

.cm-scorepad__rally {
  min-width: 4.8rem;
  min-height: 2.85rem;
  padding: 0 0.7rem;
  border-radius: 16px;
  background: var(--sp-panel);
  display: grid;
  place-items: center;
  font-size: 0.82rem;
  font-weight: 750;
  color: var(--sp-muted);
  white-space: nowrap;
}

.cm-scorepad__tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.35rem;
  flex: 0 0 auto;
}

.cm-scorepad__tags button,
.cm-scorepad__tag-more {
  min-height: 2.1rem;
  padding: 0.25rem 0.65rem;
  border-radius: 999px;
  border: 1px solid var(--sp-line);
  background: var(--sp-card);
  color: var(--sp-ink);
  font-size: 0.72rem;
  font-weight: 750;
  cursor: pointer;
}

.cm-scorepad__tags button.is-on {
  border-color: color-mix(in srgb, var(--sp-home) 50%, var(--sp-line));
  background: color-mix(in srgb, var(--sp-home) 14%, var(--sp-card));
  color: var(--sp-home);
}

.cm-scorepad__tag-more {
  width: 2.1rem;
  padding: 0;
  display: grid;
  place-items: center;
  border-radius: 12px;
}


.cm-scorepad__footer {
  flex: 0 1 auto;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  max-height: 28%;
  min-height: 0;
  overflow: hidden;
}

.cm-scorepad__history {
  flex: 0 1 auto;
  min-height: 0;
  overflow: hidden;
}

.cm-scorepad__history h3 {
  margin: 0 0 0.25rem;
  font-size: 0.75rem;
  font-weight: 800;
}

.cm-scorepad__history ol {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.35rem;
}

.cm-scorepad__history li {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.15rem;
  padding: 0.45rem 0.2rem;
  border-radius: 14px;
  background: var(--sp-panel);
  border: 2px solid transparent;
  text-align: center;
}

.cm-scorepad__history li span {
  font-size: 0.58rem;
  font-weight: 750;
  color: var(--sp-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.cm-scorepad__history li strong {
  font-size: 0.82rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.cm-scorepad__history li.is-live {
  border-color: var(--sp-home);
  background: color-mix(in srgb, var(--sp-home) 10%, var(--sp-card));
}

.cm-scorepad__sheet-btn,
.cm-scorepad__ghost,
.cm-scorepad__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 2.85rem;
  border: 0;
  border-radius: 16px;
  font-size: 0.92rem;
  font-weight: 750;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.cm-scorepad__sheet-btn,
.cm-scorepad__ghost {
  background: var(--sp-panel);
  color: var(--sp-ink);
}

.cm-scorepad__cta {
  background: var(--sp-home);
  color: #fff;
}

.cm-scorepad__edit-bar {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 0.4rem;
}

.cm-scorepad__sheet {
  position: absolute;
  inset: 0;
  z-index: 20;
  background: rgba(8, 12, 20, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0.75rem;
}

.cm-scorepad__sheet-card {
  width: min(100%, 28rem);
  max-height: min(80dvh, 34rem);
  overflow: auto;
  border-radius: 20px;
  background: var(--sp-card);
  color: var(--sp-ink);
  border: 1px solid var(--sp-line);
  padding: 0.85rem 0.9rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.cm-scorepad__sheet-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.cm-scorepad__sheet-head h2 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
}

.cm-scorepad__sheet-head button {
  width: 2.2rem;
  height: 2.2rem;
  border: 0;
  border-radius: 10px;
  background: var(--sp-panel);
  color: var(--sp-ink);
  display: grid;
  place-items: center;
  cursor: pointer;
}

.cm-scorepad__sheet-card > p {
  margin: 0;
  color: var(--sp-muted);
  font-size: 0.82rem;
  font-weight: 650;
}

.cm-scorepad__sheet-body {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.cm-scorepad__sheet-body section p {
  margin: 0 0 0.3rem;
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--sp-muted);
}

.cm-scorepad__sheet-body section > div {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.cm-scorepad__sheet-body button {
  min-height: 2.15rem;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  border: 1px solid var(--sp-line);
  background: var(--sp-panel);
  color: var(--sp-ink);
  font-size: 0.78rem;
  font-weight: 750;
  cursor: pointer;
}

.cm-scorepad__sheet-body button.is-on {
  border-color: color-mix(in srgb, var(--sp-home) 50%, var(--sp-line));
  background: color-mix(in srgb, var(--sp-home) 14%, transparent);
  color: var(--sp-home);
}

.cm-scorepad__end-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0.45rem;
  align-items: end;
}

.cm-scorepad__end-row label {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.7rem;
  font-weight: 700;
  color: var(--sp-muted);
  min-width: 0;
}

.cm-scorepad__end-row input {
  min-height: 3.1rem;
  border-radius: 12px;
  border: 2px solid color-mix(in srgb, var(--sp-home) 40%, var(--sp-line));
  background: var(--sp-panel);
  color: var(--sp-ink);
  font-size: 1.5rem;
  font-weight: 800;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.cm-scorepad__end-row em {
  font-style: normal;
  font-size: 1.3rem;
  font-weight: 800;
  padding-bottom: 0.65rem;
}

.cm-scorepad__end-error {
  margin: 0;
  color: #e11d48;
  font-size: 0.8rem;
  font-weight: 700;
}

/* Landscape phone: thumb rails on the edges, score centered on each half. */
@media (orientation: landscape) and (max-height: 640px) {
  .cm-scorepad,
  .cm-page--score-pad .cm-scorepad {
    gap: 0.15rem;
    padding: 0.1rem 0 0.15rem;
    overflow: hidden;
  }

  .cm-scorepad__head,
  .cm-scorepad__record,
  .cm-scorepad__cue,
  .cm-scorepad__banner,
  .cm-scorepad__cta,
  .cm-scorepad__edit-bar {
    margin-left: max(0.4rem, env(safe-area-inset-left, 0px));
    margin-right: max(0.4rem, env(safe-area-inset-right, 0px));
  }

  .cm-scorepad__head {
    gap: 0.2rem;
  }

  .cm-scorepad__back,
  .cm-scorepad__more,
  .cm-scorepad__reset {
    width: 2.25rem;
    height: 2.25rem;
  }

  .cm-scorepad__title strong {
    font-size: 0.88rem;
  }

  .cm-scorepad__title span,
  .cm-scorepad__badge span {
    display: none;
  }

  .cm-scorepad__badge {
    padding: 0.2rem 0.4rem;
  }

  .cm-scorepad__badge em {
    font-size: 0.65rem;
  }

  .cm-scorepad__board {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: minmax(0, 1fr);
    gap: 0;
    min-height: 0;
    flex: 1 1 auto;
    padding-left: env(safe-area-inset-left, 0px);
    padding-right: env(safe-area-inset-right, 0px);
  }

  .cm-scorepad__card {
    min-width: 0;
    padding: 0.2rem 0.35rem 0.15rem;
    gap: 0.05rem;
    border-radius: 0;
    box-shadow: none;
  }

  .cm-scorepad__board > .cm-scorepad__card:last-child {
    box-shadow: inset 1px 0 0 var(--sp-line);
  }

  .cm-scorepad__board > .cm-scorepad__card:first-child {
    grid-template-columns: 5rem minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr);
    grid-template-areas:
      "ops who"
      "ops score";
    padding-left: 0;
  }

  .cm-scorepad__board > .cm-scorepad__card:last-child {
    grid-template-columns: minmax(0, 1fr) 5rem;
    grid-template-rows: auto minmax(0, 1fr);
    grid-template-areas:
      "who ops"
      "score ops";
    padding-right: 0;
  }

  .cm-scorepad__board > .cm-scorepad__card:first-child:has(.cm-scorepad__ops.is-empty),
  .cm-scorepad__board > .cm-scorepad__card:last-child:has(.cm-scorepad__ops.is-empty) {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas:
      "who"
      "score";
  }

  .cm-scorepad__card-top {
    grid-area: who;
    position: relative;
    min-height: 0;
    min-width: 0;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    padding: 0 0.2rem 0.85rem;
  }

  .cm-scorepad__who-row {
    flex: 1 1 auto;
    min-width: 0;
    justify-content: center;
    max-width: 100%;
  }

  .cm-scorepad__who-block {
    flex: 1 1 auto;
    min-width: 0;
    align-items: stretch;
    max-width: 100%;
    text-align: center;
  }

  .cm-scorepad__rank {
    position: absolute;
    left: 0.15rem;
    right: 0.15rem;
    bottom: 0;
    align-items: stretch;
    min-width: 0;
  }

  .cm-scorepad__who,
  .cm-scorepad__rank-line {
    min-width: 0;
    max-width: 100%;
    text-align: center;
  }

  .cm-scorepad__rank-line {
    font-size: 0.55rem;
  }

  .cm-scorepad__meta {
    flex-direction: row;
    align-items: center;
    gap: 0.35rem;
  }

  .cm-scorepad__serve {
    font-size: 0;
    gap: 0;
    padding: 0.22rem;
  }

  .cm-scorepad__serve i {
    width: 0.42rem;
    height: 0.42rem;
  }

  .cm-scorepad__who {
    font-size: clamp(0.72rem, 2.1vw, 0.95rem);
    text-align: center;
  }

  .cm-scorepad__games {
    flex-direction: column;
    align-items: center;
    gap: 0;
    line-height: 1;
  }

  .cm-scorepad__games strong {
    font-size: clamp(1.05rem, 3vw, 1.45rem);
  }

  .cm-scorepad__games em {
    font-size: 0.55rem;
    letter-spacing: 0.08em;
  }

  .cm-scorepad__club-logo {
    width: 1.35rem !important;
    height: 1.35rem !important;
    max-width: 1.35rem;
    max-height: 1.35rem;
    border-radius: 6px !important;
  }

  .cm-scorepad__club-logo .club-logo-mark__letter {
    font-size: 0.55rem;
  }

  .cm-scorepad__score-wrap {
    grid-area: score;
  }

  .cm-scorepad__ops {
    grid-area: ops;
    display: flex;
    flex-direction: column;
    grid-template-columns: none;
    gap: 0.35rem;
    min-height: 0;
    height: auto;
    align-self: stretch;
    padding: 0;
  }

  .cm-scorepad__board > .cm-scorepad__card:first-child .cm-scorepad__ops {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 5rem;
  }

  .cm-scorepad__board > .cm-scorepad__card:last-child .cm-scorepad__ops {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 5rem;
  }

  .cm-scorepad__ops.is-empty {
    display: none;
  }

  .cm-scorepad__minus {
    flex: 0.72 1;
    min-height: 2.75rem;
    height: auto;
    border-radius: 16px;
  }

  .cm-scorepad__plus {
    flex: 1.45 1;
    min-height: 3.25rem;
    height: auto;
    border-radius: 18px;
  }

  .cm-scorepad__board > .cm-scorepad__card:first-child .cm-scorepad__minus,
  .cm-scorepad__board > .cm-scorepad__card:first-child .cm-scorepad__plus {
    border-radius: 0 16px 16px 0;
  }

  .cm-scorepad__board > .cm-scorepad__card:last-child .cm-scorepad__minus,
  .cm-scorepad__board > .cm-scorepad__card:last-child .cm-scorepad__plus {
    border-radius: 16px 0 0 16px;
  }

  .cm-scorepad__minus svg {
    width: 26px;
    height: 26px;
  }

  .cm-scorepad__plus svg {
    width: 34px;
    height: 34px;
  }

  .cm-scorepad__dock {
    flex-direction: row;
    align-items: stretch;
    gap: 0.35rem;
    flex: 0 0 auto;
    margin-top: auto;
    padding: 0.28rem max(0.4rem, env(safe-area-inset-right, 0px)) 0.12rem
      max(0.4rem, env(safe-area-inset-left, 0px));
    border-top: 1px solid var(--sp-line);
    background: color-mix(in srgb, var(--sp-card) 92%, transparent);
  }

  .cm-scorepad__midrow {
    width: auto;
    flex: 0 0 auto;
    grid-template-columns: auto auto;
    gap: 0.3rem;
  }

  .cm-scorepad__undo,
  .cm-scorepad__rally {
    min-height: 2.45rem;
    height: 100%;
    font-size: 0.72rem;
    border-radius: 14px;
  }

  .cm-scorepad__undo {
    width: 2.45rem;
    min-width: 2.45rem;
    padding: 0;
  }

  .cm-scorepad__undo span {
    display: none;
  }

  .cm-scorepad__rally {
    min-width: 0;
    padding: 0 0.45rem;
  }

  .cm-scorepad__dock .cm-outcome {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    align-self: stretch;
  }

  .cm-scorepad__dock .cm-outcome__btn {
    flex-direction: column;
    gap: 0.08rem;
    min-height: 2.45rem;
    padding: 0.16rem 0.12rem;
    border-radius: 12px;
  }

  /* Marks only in landscape — five labels do not fit beside the score. */
  .cm-scorepad__dock .cm-outcome__text {
    display: none;
  }

  .cm-scorepad__dock .cm-outcome__mark {
    font-size: 1.05rem;
  }

  .cm-scorepad__history,
  .cm-scorepad__footer {
    display: none;
  }

  .cm-scorepad__cue,
  .cm-scorepad__banner {
    font-size: 0.72rem;
    padding: 0.25rem 0.45rem;
  }

  .cm-scorepad__cta {
    min-height: 2.5rem;
    font-size: 0.78rem;
    width: auto;
  }

  .cm-scorepad__record {
    min-height: 2.15rem;
    font-size: 0.75rem;
    width: auto;
    align-self: center;
    padding: 0 0.85rem;
  }
}

/* Page chrome: hide header / stamps / tabs — true fullscreen score pad */
.cm-page--score-pad > .cm-head,
.cm-page--score-pad > .cm-cam-status,
.cm-page--score-pad > .cm-tables,
.cm-page--score-pad > .cm-match-status,
.cm-page--score-pad > .cm-actions,
.cm-page--score-pad > .cm-dock,
.cm-page--score-pad > .cm-stamps-wrap,
.cm-page--score-pad > .cm-tagdock,
.cm-page--score-pad > .cm-banner,
.cm-page--score-pad > .cm-tabs {
  display: none !important;
}

.cm-page--score-pad {
  padding: env(safe-area-inset-top, 0px) 0
    env(safe-area-inset-bottom, 0px);
  gap: 0;
  height: var(--lt-vvh, 100dvh);
  max-height: var(--lt-vvh, 100dvh);
}

html.cm-immersive .cm-page--score-pad,
html:fullscreen .cm-page--score-pad,
html:-webkit-full-screen .cm-page--score-pad {
  height: var(--lt-vvh, 100dvh);
  max-height: var(--lt-vvh, 100dvh);
}

.cm-page--score-pad .cm-body {
  flex: 1 1;
  min-height: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.cm-page--score-pad .cm-panel {
  flex: 1 1;
  min-height: 0;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.cm-page--score-pad .cm-live {
  margin: 0;
  padding: 0;
  gap: 0;
  overflow: hidden;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.cm-page--score-pad .cm-scorepad {
  flex: 1 1;
  min-height: 0;
  padding-left: 0.55rem;
  padding-right: 0.55rem;
  padding-bottom: max(0.35rem, env(safe-area-inset-bottom, 0px));
}

@media (orientation: landscape) and (max-height: 640px) {
  .cm-page--score-pad .cm-scorepad {
    padding-left: 0;
    padding-right: 0;
  }
}

/* Portrait: score fills the card, empty ± row does not reserve space */
@media (orientation: portrait) {
  .cm-scorepad__card {
    padding: 0.28rem 0.4rem 0.3rem;
    gap: 0.06rem;
  }

  .cm-scorepad__score-wrap {
    align-items: center;
    justify-content: center;
  }

  .cm-scorepad__ops.is-empty {
    display: none;
  }
}

/* Short portrait phones: keep ± inside the cards; free room for tags */
@media (orientation: portrait) and (max-height: 780px) {
  .cm-scorepad {
    gap: 0.3rem;
    padding: 0.25rem 0.55rem 0.4rem;
  }

  .cm-scorepad__ops {
    min-height: 2.15rem;
  }

  .cm-scorepad__plus,
  .cm-scorepad__minus {
    min-height: 2.15rem;
    height: 2.15rem;
  }

  .cm-scorepad__undo,
  .cm-scorepad__rally {
    min-height: 2.2rem;
  }

  .cm-scorepad__dock {
    gap: 0.28rem;
  }

  .cm-scorepad__dock .cm-outcome__btn {
    min-height: 2.2rem;
    padding: 0.16rem 0.08rem;
  }

  .cm-scorepad__dock .cm-outcome__text {
    font-size: 0.56rem;
  }

  /* History steals the viewport under the tags — hide on short phones. */
  .cm-scorepad__footer {
    display: none;
  }

  .cm-scorepad__sheet-btn {
    min-height: 2.35rem;
  }
}

@media (orientation: portrait) and (max-height: 640px) {
  .cm-scorepad__dock .cm-outcome__text {
    display: none;
  }

  .cm-scorepad__dock .cm-outcome__mark {
    font-size: 1.05rem;
  }

  .cm-scorepad__dock .cm-outcome__btn {
    min-height: 2.05rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cm-scorepad__plus,
  .cm-scorepad__minus,
  .cm-scorepad__pts {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChampionshipScorePad.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,uCAAuC;EACvC,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC;yCACuC;EACvC,6CAA6C;;EAE7C,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,qBAAqB;EACrB,iCAAiC;EACjC,oBAAoB;EACpB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;EAC1B,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kEAAkE;EAClE,qEAAqE;AACvE;;AAEA;EACE,SAAW;EACX,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,iDAAiD;EACjD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,4CAA4C;EAC5C,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,+BAA+B;EAC/B,sGAAsG;EACtG,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,+DAA+D;EAC/D,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,yFAAyF;EACzF,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe,EAAE,sCAAsC;EACvD,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mGAAmG;EACnG,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,WAAW;EACX,iGAAiG;AACnG;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,0EAA0E;EAC1E,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB;;;;GAIC;AACH;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;EAChC,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oEAAoE;EACpE,kEAAkE;EAClE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,kEAAkE;AACpE;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oEAAoE;EACpE,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wEAAwE;EACxE,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE;;IAEE,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;;;;;IAME,wDAAwD;IACxD,0DAA0D;EAC5D;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,kCAAkC;IAClC,MAAM;IACN,aAAa;IACb,cAAc;IACd,4CAA4C;IAC5C,8CAA8C;EAChD;;EAEA;IACE,YAAY;IACZ,+BAA+B;IAC/B,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,0CAA0C;IAC1C,uCAAuC;IACvC;;iBAEa;IACb,eAAe;EACjB;;EAEA;IACE,0CAA0C;IAC1C,uCAAuC;IACvC;;iBAEa;IACb,gBAAgB;EAClB;;EAEA;;IAEE,qCAAqC;IACrC;;aAES;EACX;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,SAAS;IACT,oBAAoB;IACpB,YAAY;EACd;;EAEA;;IAEE,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,MAAM;IACN,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,MAAM;IACN,cAAc;EAChB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB;iDAC6C;IAC7C,oCAAoC;IACpC,+DAA+D;EACjE;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,WAAW;EACb;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA,uEAAuE;EACvE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA,yEAAyE;AACzE;;;;;;;;;;EAUE,wBAAwB;AAC1B;;AAEA;EACE;oCACkC;EAClC,MAAM;EACN,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;;;EAGE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,MAAM;EACN,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,uEAAuE;AACvE;EACE;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,uEAAuE;AACvE;EACE;IACE,WAAW;IACX,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA,uEAAuE;EACvE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF","sourcesContent":["/* Match score pad — mockup layout, club brand accents, bottom tabs stay visible */\n\n.cm-scorepad {\n  --sp-home: var(--brand-primary, #0877bc);\n  --sp-away: var(--brand-secondary, #c2410c);\n  --sp-home-soft: rgba(8, 119, 188, 0.12);\n  --sp-away-soft: rgba(194, 65, 12, 0.12);\n  --sp-ink: #0f172a;\n  --sp-muted: #64748b;\n  --sp-line: rgba(15, 23, 42, 0.08);\n  --sp-panel: #f1f5f9;\n  --sp-card: #ffffff;\n  --sp-ease: cubic-bezier(0.16, 1, 0.3, 1);\n  --sp-display: \"DIN Alternate\", \"Bahnschrift\", \"Roboto Condensed\",\n    \"Arial Narrow\", system-ui, sans-serif;\n  --sp-safe-b: env(safe-area-inset-bottom, 0px);\n\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  padding: 0.35rem 0.7rem 0.55rem;\n  overflow: hidden auto;\n  -webkit-overflow-scrolling: touch;\n  color: var(--sp-ink);\n  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);\n}\n\n.cm-scorepad--dark {\n  --sp-ink: #f1f5f9;\n  --sp-muted: #94a3b8;\n  --sp-line: rgba(248, 250, 252, 0.1);\n  --sp-panel: #1e293b;\n  --sp-card: #121a2b;\n  background: linear-gradient(180deg, #0e1524 0%, #070b14 100%);\n}\n\n.cm-scorepad__head {\n  position: relative;\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 0.35rem;\n  flex: 0 0 auto;\n}\n\n.cm-scorepad__record {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  min-height: 2.55rem;\n  border: 0;\n  border-radius: 999px;\n  background: #e11d48;\n  color: #fff;\n  font: inherit;\n  font-size: 0.88rem;\n  font-weight: 750;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\n.cm-scorepad__record:disabled {\n  opacity: 0.55;\n  cursor: wait;\n}\n\n.cm-scorepad__record.is-live {\n  background: #111827;\n  box-shadow: inset 0 0 0 2px #e11d48;\n}\n\n.cm-scorepad--dark .cm-scorepad__record.is-live {\n  background: #1e293b;\n}\n\n.cm-scorepad__head-actions {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  flex-shrink: 0;\n}\n\n.cm-scorepad__back,\n.cm-scorepad__more,\n.cm-scorepad__reset {\n  width: 2.35rem;\n  height: 2.35rem;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  color: var(--sp-ink);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  flex-shrink: 0;\n}\n\n.cm-scorepad__reset {\n  color: #e11d48;\n  background: color-mix(in srgb, #e11d48 10%, transparent);\n}\n\n.cm-scorepad__reset:disabled {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.cm-scorepad__title {\n  min-width: 0;\n  text-align: center;\n}\n\n.cm-scorepad__title strong {\n  display: block;\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.cm-scorepad__title span {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 650;\n  color: var(--sp-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cm-scorepad__badge {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.1rem;\n  padding: 0.35rem 0.55rem;\n  border-radius: 12px;\n  background: var(--sp-panel);\n  border: 1px solid var(--sp-line);\n}\n\n.cm-scorepad__badge em {\n  font-style: normal;\n  font-size: 0.72rem;\n  font-weight: 800;\n}\n\n.cm-scorepad__badge span {\n  font-size: 0.62rem;\n  font-weight: 650;\n  color: var(--sp-muted);\n  white-space: nowrap;\n}\n\n.cm-scorepad__menu {\n  position: absolute;\n  top: 2.7rem;\n  right: 0;\n  z-index: 8;\n  min-width: 11rem;\n  padding: 0.35rem;\n  border-radius: 14px;\n  border: 1px solid var(--sp-line);\n  background: var(--sp-card);\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.16);\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.cm-scorepad__menu button {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-height: 2.35rem;\n  padding: 0.35rem 0.55rem;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--sp-ink);\n  font-size: 0.82rem;\n  font-weight: 700;\n  cursor: pointer;\n  text-align: left;\n}\n\n.cm-scorepad__menu button.is-danger {\n  color: #e11d48;\n}\n\n.cm-scorepad__menu button:active {\n  background: var(--sp-panel);\n}\n\n.cm-scorepad__cue {\n  margin: 0;\n  text-align: center;\n  font-size: 0.82rem;\n  font-weight: 800;\n  padding: 0.4rem 0.6rem;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--sp-home) 16%, var(--sp-card));\n  border: 1px solid color-mix(in srgb, var(--sp-home) 35%, transparent);\n}\n\n.cm-scorepad__board {\n  flex: 1 1 0;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 0.35rem;\n  overflow: hidden;\n}\n\n.cm-scorepad__card {\n  position: relative;\n  min-height: 0;\n  max-height: 100%;\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr) auto;\n  gap: 0.2rem;\n  padding: 0.4rem 0.5rem 0.45rem;\n  border-radius: 18px;\n  border: 1px solid transparent;\n  background: var(--sp-home-soft);\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--sp-card-accent, var(--sp-home)) 18%, transparent);\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.cm-scorepad__card--away {\n  background: var(--sp-away-soft);\n}\n\n.cm-scorepad__card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.35rem;\n  min-width: 0;\n  min-height: 1.35rem;\n}\n\n.cm-scorepad__meta {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.cm-scorepad__games {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.22rem;\n  font-size: 0.65rem;\n  font-weight: 700;\n  color: var(--sp-muted);\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-scorepad__games strong {\n  font-size: 0.95rem;\n  font-weight: 800;\n  color: var(--sp-ink);\n  letter-spacing: -0.03em;\n}\n\n.cm-scorepad__games em {\n  font-style: normal;\n  font-size: 0.58rem;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.cm-scorepad__club-logo {\n  width: 1.85rem !important;\n  height: 1.85rem !important;\n  max-width: 1.85rem;\n  max-height: 1.85rem;\n  border-radius: 8px !important;\n  object-fit: contain !important;\n  background: color-mix(in srgb, var(--sp-card) 80%, transparent);\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.12);\n}\n\n.cm-scorepad__club-logo.club-logo-mark--fallback {\n  border-radius: 8px !important;\n}\n\n.cm-scorepad__club-logo .club-logo-mark__letter {\n  font-size: 0.72rem;\n}\n\n.cm-scorepad__who-row {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex: 1 1 auto;\n}\n\n.cm-scorepad__who-block {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.06rem;\n  flex: 1 1 auto;\n}\n\n.cm-scorepad__rank {\n  display: flex;\n  flex-direction: column;\n  gap: 0.02rem;\n  min-width: 0;\n}\n\n.cm-scorepad__rank-line {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.62rem;\n  font-weight: 750;\n  letter-spacing: 0.01em;\n  line-height: 1.15;\n  color: var(--sp-muted);\n  font-variant-numeric: tabular-nums;\n  text-transform: none;\n}\n\n.cm-scorepad__serve {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.22rem;\n  padding: 0.14rem 0.42rem;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--sp-card-accent, var(--sp-home)) 18%, var(--sp-card));\n  color: var(--sp-card-accent, var(--sp-home));\n  font-size: 0.55rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.cm-scorepad__serve i {\n  width: 0.35rem;\n  height: 0.35rem;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.cm-scorepad__who {\n  min-width: 0;\n  font-size: clamp(0.7rem, 2.6vw, 0.85rem);\n  font-weight: 800;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  line-height: 1.15;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-scorepad__score-wrap {\n  min-height: 0;\n  width: 100%;\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.cm-scorepad__pts,\n.cm-scorepad__pts-input {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  width: auto;\n  min-width: 0;\n  min-height: 0;\n  max-width: 100%;\n  max-height: 100%;\n  text-align: center;\n  font-family: var(--sp-display);\n  font-size: 96px; /* JS fit overrides via inline style */\n  font-weight: 800;\n  letter-spacing: -0.04em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: var(--sp-ink);\n  white-space: nowrap;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.cm-scorepad__pts:not(.cm-scorepad__pts--read) {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.cm-scorepad__pts-num {\n  display: block;\n  line-height: 1;\n  letter-spacing: -0.04em;\n  font-weight: 800;\n  font-family: inherit;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-scorepad__pts:disabled,\n.cm-scorepad__pts--read {\n  cursor: default;\n}\n\n.cm-scorepad__pts--read {\n  display: block;\n  line-height: 1;\n  max-width: 100%;\n  max-height: 100%;\n  pointer-events: none;\n}\n\n.cm-scorepad__pts:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.cm-scorepad__pts-input {\n  outline: none;\n  border-bottom: 3px solid color-mix(in srgb, var(--sp-card-accent, var(--sp-home)) 55%, transparent);\n  max-width: 4.5ch;\n  margin: 0 auto;\n  caret-color: var(--sp-card-accent, var(--sp-home));\n}\n\n.cm-scorepad__ops {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr;\n  gap: 0.3rem;\n  flex-shrink: 0;\n  min-height: 2.4rem;\n}\n\n.cm-scorepad__ops.is-empty {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.cm-scorepad__plus,\n.cm-scorepad__minus {\n  min-height: 2.4rem;\n  height: 2.4rem;\n  padding: 0;\n  border: 0;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  transition: transform 0.12s var(--sp-ease);\n}\n\n.cm-scorepad__plus svg,\n.cm-scorepad__minus svg {\n  width: 22px;\n  height: 22px;\n}\n\n.cm-scorepad__plus:active,\n.cm-scorepad__minus:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\n.cm-scorepad__plus:focus-visible,\n.cm-scorepad__minus:focus-visible {\n  outline: 2px solid var(--sp-ink);\n  outline-offset: 2px;\n}\n\n.cm-scorepad__plus {\n  background: var(--sp-card-accent, var(--sp-home));\n  color: #fff;\n  box-shadow: 0 5px 12px color-mix(in srgb, var(--sp-card-accent, var(--sp-home)) 32%, transparent);\n}\n\n.cm-scorepad__minus {\n  background: var(--sp-panel);\n  color: var(--sp-ink);\n}\n\n.cm-scorepad__minus:disabled {\n  opacity: 0.35;\n  pointer-events: none;\n}\n\n.cm-scorepad__banner {\n  margin: 0;\n  text-align: center;\n  font-size: 0.85rem;\n  font-weight: 800;\n  padding: 0.45rem 0.65rem;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--sp-home) 14%, var(--sp-card));\n}\n\n.cm-scorepad__dock {\n  /* Keep tags under the score — never let them paint over the big digits. */\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  flex: 0 0 auto;\n  margin-top: auto;\n  min-width: 0;\n  padding-top: 0.2rem;\n  background: linear-gradient(\n    180deg,\n    transparent 0%,\n    color-mix(in srgb, var(--sp-card) 88%, transparent) 28%\n  );\n}\n\n.cm-scorepad__dock .cm-outcome {\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n.cm-scorepad__dock .cm-outcome__btn {\n  min-height: 2.45rem;\n  padding: 0.22rem 0.12rem 0.26rem;\n}\n\n.cm-scorepad__dock .cm-outcome__text {\n  font-size: 0.62rem;\n}\n\n.cm-scorepad__midrow {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 0.45rem;\n  align-items: center;\n  flex: 0 0 auto;\n}\n\n.cm-scorepad__undo {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  min-height: 2.85rem;\n  border: 0;\n  border-radius: 16px;\n  background: var(--sp-panel);\n  color: var(--sp-ink);\n  font-size: 0.9rem;\n  font-weight: 750;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\n.cm-scorepad__undo:disabled {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.cm-scorepad__rally {\n  min-width: 4.8rem;\n  min-height: 2.85rem;\n  padding: 0 0.7rem;\n  border-radius: 16px;\n  background: var(--sp-panel);\n  display: grid;\n  place-items: center;\n  font-size: 0.82rem;\n  font-weight: 750;\n  color: var(--sp-muted);\n  white-space: nowrap;\n}\n\n.cm-scorepad__tags {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.35rem;\n  flex: 0 0 auto;\n}\n\n.cm-scorepad__tags button,\n.cm-scorepad__tag-more {\n  min-height: 2.1rem;\n  padding: 0.25rem 0.65rem;\n  border-radius: 999px;\n  border: 1px solid var(--sp-line);\n  background: var(--sp-card);\n  color: var(--sp-ink);\n  font-size: 0.72rem;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.cm-scorepad__tags button.is-on {\n  border-color: color-mix(in srgb, var(--sp-home) 50%, var(--sp-line));\n  background: color-mix(in srgb, var(--sp-home) 14%, var(--sp-card));\n  color: var(--sp-home);\n}\n\n.cm-scorepad__tag-more {\n  width: 2.1rem;\n  padding: 0;\n  display: grid;\n  place-items: center;\n  border-radius: 12px;\n}\n\n\n.cm-scorepad__footer {\n  flex: 0 1 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  max-height: 28%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.cm-scorepad__history {\n  flex: 0 1 auto;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.cm-scorepad__history h3 {\n  margin: 0 0 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 800;\n}\n\n.cm-scorepad__history ol {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0.35rem;\n}\n\n.cm-scorepad__history li {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.15rem;\n  padding: 0.45rem 0.2rem;\n  border-radius: 14px;\n  background: var(--sp-panel);\n  border: 2px solid transparent;\n  text-align: center;\n}\n\n.cm-scorepad__history li span {\n  font-size: 0.58rem;\n  font-weight: 750;\n  color: var(--sp-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.cm-scorepad__history li strong {\n  font-size: 0.82rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-scorepad__history li.is-live {\n  border-color: var(--sp-home);\n  background: color-mix(in srgb, var(--sp-home) 10%, var(--sp-card));\n}\n\n.cm-scorepad__sheet-btn,\n.cm-scorepad__ghost,\n.cm-scorepad__cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n  min-height: 2.85rem;\n  border: 0;\n  border-radius: 16px;\n  font-size: 0.92rem;\n  font-weight: 750;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n}\n\n.cm-scorepad__sheet-btn,\n.cm-scorepad__ghost {\n  background: var(--sp-panel);\n  color: var(--sp-ink);\n}\n\n.cm-scorepad__cta {\n  background: var(--sp-home);\n  color: #fff;\n}\n\n.cm-scorepad__edit-bar {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr;\n  gap: 0.4rem;\n}\n\n.cm-scorepad__sheet {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  background: rgba(8, 12, 20, 0.5);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 0.75rem;\n}\n\n.cm-scorepad__sheet-card {\n  width: min(100%, 28rem);\n  max-height: min(80dvh, 34rem);\n  overflow: auto;\n  border-radius: 20px;\n  background: var(--sp-card);\n  color: var(--sp-ink);\n  border: 1px solid var(--sp-line);\n  padding: 0.85rem 0.9rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.cm-scorepad__sheet-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.cm-scorepad__sheet-head h2 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 800;\n}\n\n.cm-scorepad__sheet-head button {\n  width: 2.2rem;\n  height: 2.2rem;\n  border: 0;\n  border-radius: 10px;\n  background: var(--sp-panel);\n  color: var(--sp-ink);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n}\n\n.cm-scorepad__sheet-card > p {\n  margin: 0;\n  color: var(--sp-muted);\n  font-size: 0.82rem;\n  font-weight: 650;\n}\n\n.cm-scorepad__sheet-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n\n.cm-scorepad__sheet-body section p {\n  margin: 0 0 0.3rem;\n  font-size: 0.65rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--sp-muted);\n}\n\n.cm-scorepad__sheet-body section > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.cm-scorepad__sheet-body button {\n  min-height: 2.15rem;\n  padding: 0.3rem 0.65rem;\n  border-radius: 999px;\n  border: 1px solid var(--sp-line);\n  background: var(--sp-panel);\n  color: var(--sp-ink);\n  font-size: 0.78rem;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.cm-scorepad__sheet-body button.is-on {\n  border-color: color-mix(in srgb, var(--sp-home) 50%, var(--sp-line));\n  background: color-mix(in srgb, var(--sp-home) 14%, transparent);\n  color: var(--sp-home);\n}\n\n.cm-scorepad__end-row {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 0.45rem;\n  align-items: end;\n}\n\n.cm-scorepad__end-row label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: var(--sp-muted);\n  min-width: 0;\n}\n\n.cm-scorepad__end-row input {\n  min-height: 3.1rem;\n  border-radius: 12px;\n  border: 2px solid color-mix(in srgb, var(--sp-home) 40%, var(--sp-line));\n  background: var(--sp-panel);\n  color: var(--sp-ink);\n  font-size: 1.5rem;\n  font-weight: 800;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-scorepad__end-row em {\n  font-style: normal;\n  font-size: 1.3rem;\n  font-weight: 800;\n  padding-bottom: 0.65rem;\n}\n\n.cm-scorepad__end-error {\n  margin: 0;\n  color: #e11d48;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n/* Landscape phone: thumb rails on the edges, score centered on each half. */\n@media (orientation: landscape) and (max-height: 640px) {\n  .cm-scorepad,\n  .cm-page--score-pad .cm-scorepad {\n    gap: 0.15rem;\n    padding: 0.1rem 0 0.15rem;\n    overflow: hidden;\n  }\n\n  .cm-scorepad__head,\n  .cm-scorepad__record,\n  .cm-scorepad__cue,\n  .cm-scorepad__banner,\n  .cm-scorepad__cta,\n  .cm-scorepad__edit-bar {\n    margin-left: max(0.4rem, env(safe-area-inset-left, 0px));\n    margin-right: max(0.4rem, env(safe-area-inset-right, 0px));\n  }\n\n  .cm-scorepad__head {\n    gap: 0.2rem;\n  }\n\n  .cm-scorepad__back,\n  .cm-scorepad__more,\n  .cm-scorepad__reset {\n    width: 2.25rem;\n    height: 2.25rem;\n  }\n\n  .cm-scorepad__title strong {\n    font-size: 0.88rem;\n  }\n\n  .cm-scorepad__title span,\n  .cm-scorepad__badge span {\n    display: none;\n  }\n\n  .cm-scorepad__badge {\n    padding: 0.2rem 0.4rem;\n  }\n\n  .cm-scorepad__badge em {\n    font-size: 0.65rem;\n  }\n\n  .cm-scorepad__board {\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: minmax(0, 1fr);\n    gap: 0;\n    min-height: 0;\n    flex: 1 1 auto;\n    padding-left: env(safe-area-inset-left, 0px);\n    padding-right: env(safe-area-inset-right, 0px);\n  }\n\n  .cm-scorepad__card {\n    min-width: 0;\n    padding: 0.2rem 0.35rem 0.15rem;\n    gap: 0.05rem;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  .cm-scorepad__board > .cm-scorepad__card:last-child {\n    box-shadow: inset 1px 0 0 var(--sp-line);\n  }\n\n  .cm-scorepad__board > .cm-scorepad__card:first-child {\n    grid-template-columns: 5rem minmax(0, 1fr);\n    grid-template-rows: auto minmax(0, 1fr);\n    grid-template-areas:\n      \"ops who\"\n      \"ops score\";\n    padding-left: 0;\n  }\n\n  .cm-scorepad__board > .cm-scorepad__card:last-child {\n    grid-template-columns: minmax(0, 1fr) 5rem;\n    grid-template-rows: auto minmax(0, 1fr);\n    grid-template-areas:\n      \"who ops\"\n      \"score ops\";\n    padding-right: 0;\n  }\n\n  .cm-scorepad__board > .cm-scorepad__card:first-child:has(.cm-scorepad__ops.is-empty),\n  .cm-scorepad__board > .cm-scorepad__card:last-child:has(.cm-scorepad__ops.is-empty) {\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-areas:\n      \"who\"\n      \"score\";\n  }\n\n  .cm-scorepad__card-top {\n    grid-area: who;\n    position: relative;\n    min-height: 0;\n    min-width: 0;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: center;\n    gap: 0.4rem;\n    padding: 0 0.2rem 0.85rem;\n  }\n\n  .cm-scorepad__who-row {\n    flex: 1 1 auto;\n    min-width: 0;\n    justify-content: center;\n    max-width: 100%;\n  }\n\n  .cm-scorepad__who-block {\n    flex: 1 1 auto;\n    min-width: 0;\n    align-items: stretch;\n    max-width: 100%;\n    text-align: center;\n  }\n\n  .cm-scorepad__rank {\n    position: absolute;\n    left: 0.15rem;\n    right: 0.15rem;\n    bottom: 0;\n    align-items: stretch;\n    min-width: 0;\n  }\n\n  .cm-scorepad__who,\n  .cm-scorepad__rank-line {\n    min-width: 0;\n    max-width: 100%;\n    text-align: center;\n  }\n\n  .cm-scorepad__rank-line {\n    font-size: 0.55rem;\n  }\n\n  .cm-scorepad__meta {\n    flex-direction: row;\n    align-items: center;\n    gap: 0.35rem;\n  }\n\n  .cm-scorepad__serve {\n    font-size: 0;\n    gap: 0;\n    padding: 0.22rem;\n  }\n\n  .cm-scorepad__serve i {\n    width: 0.42rem;\n    height: 0.42rem;\n  }\n\n  .cm-scorepad__who {\n    font-size: clamp(0.72rem, 2.1vw, 0.95rem);\n    text-align: center;\n  }\n\n  .cm-scorepad__games {\n    flex-direction: column;\n    align-items: center;\n    gap: 0;\n    line-height: 1;\n  }\n\n  .cm-scorepad__games strong {\n    font-size: clamp(1.05rem, 3vw, 1.45rem);\n  }\n\n  .cm-scorepad__games em {\n    font-size: 0.55rem;\n    letter-spacing: 0.08em;\n  }\n\n  .cm-scorepad__club-logo {\n    width: 1.35rem !important;\n    height: 1.35rem !important;\n    max-width: 1.35rem;\n    max-height: 1.35rem;\n    border-radius: 6px !important;\n  }\n\n  .cm-scorepad__club-logo .club-logo-mark__letter {\n    font-size: 0.55rem;\n  }\n\n  .cm-scorepad__score-wrap {\n    grid-area: score;\n  }\n\n  .cm-scorepad__ops {\n    grid-area: ops;\n    display: flex;\n    flex-direction: column;\n    grid-template-columns: none;\n    gap: 0.35rem;\n    min-height: 0;\n    height: auto;\n    align-self: stretch;\n    padding: 0;\n  }\n\n  .cm-scorepad__board > .cm-scorepad__card:first-child .cm-scorepad__ops {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 5rem;\n  }\n\n  .cm-scorepad__board > .cm-scorepad__card:last-child .cm-scorepad__ops {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    width: 5rem;\n  }\n\n  .cm-scorepad__ops.is-empty {\n    display: none;\n  }\n\n  .cm-scorepad__minus {\n    flex: 0.72 1 0;\n    min-height: 2.75rem;\n    height: auto;\n    border-radius: 16px;\n  }\n\n  .cm-scorepad__plus {\n    flex: 1.45 1 0;\n    min-height: 3.25rem;\n    height: auto;\n    border-radius: 18px;\n  }\n\n  .cm-scorepad__board > .cm-scorepad__card:first-child .cm-scorepad__minus,\n  .cm-scorepad__board > .cm-scorepad__card:first-child .cm-scorepad__plus {\n    border-radius: 0 16px 16px 0;\n  }\n\n  .cm-scorepad__board > .cm-scorepad__card:last-child .cm-scorepad__minus,\n  .cm-scorepad__board > .cm-scorepad__card:last-child .cm-scorepad__plus {\n    border-radius: 16px 0 0 16px;\n  }\n\n  .cm-scorepad__minus svg {\n    width: 26px;\n    height: 26px;\n  }\n\n  .cm-scorepad__plus svg {\n    width: 34px;\n    height: 34px;\n  }\n\n  .cm-scorepad__dock {\n    flex-direction: row;\n    align-items: stretch;\n    gap: 0.35rem;\n    flex: 0 0 auto;\n    margin-top: auto;\n    padding: 0.28rem max(0.4rem, env(safe-area-inset-right, 0px)) 0.12rem\n      max(0.4rem, env(safe-area-inset-left, 0px));\n    border-top: 1px solid var(--sp-line);\n    background: color-mix(in srgb, var(--sp-card) 92%, transparent);\n  }\n\n  .cm-scorepad__midrow {\n    width: auto;\n    flex: 0 0 auto;\n    grid-template-columns: auto auto;\n    gap: 0.3rem;\n  }\n\n  .cm-scorepad__undo,\n  .cm-scorepad__rally {\n    min-height: 2.45rem;\n    height: 100%;\n    font-size: 0.72rem;\n    border-radius: 14px;\n  }\n\n  .cm-scorepad__undo {\n    width: 2.45rem;\n    min-width: 2.45rem;\n    padding: 0;\n  }\n\n  .cm-scorepad__undo span {\n    display: none;\n  }\n\n  .cm-scorepad__rally {\n    min-width: 0;\n    padding: 0 0.45rem;\n  }\n\n  .cm-scorepad__dock .cm-outcome {\n    flex: 1 1 auto;\n    width: auto;\n    min-width: 0;\n    align-self: stretch;\n  }\n\n  .cm-scorepad__dock .cm-outcome__btn {\n    flex-direction: column;\n    gap: 0.08rem;\n    min-height: 2.45rem;\n    padding: 0.16rem 0.12rem;\n    border-radius: 12px;\n  }\n\n  /* Marks only in landscape — five labels do not fit beside the score. */\n  .cm-scorepad__dock .cm-outcome__text {\n    display: none;\n  }\n\n  .cm-scorepad__dock .cm-outcome__mark {\n    font-size: 1.05rem;\n  }\n\n  .cm-scorepad__history,\n  .cm-scorepad__footer {\n    display: none;\n  }\n\n  .cm-scorepad__cue,\n  .cm-scorepad__banner {\n    font-size: 0.72rem;\n    padding: 0.25rem 0.45rem;\n  }\n\n  .cm-scorepad__cta {\n    min-height: 2.5rem;\n    font-size: 0.78rem;\n    width: auto;\n  }\n\n  .cm-scorepad__record {\n    min-height: 2.15rem;\n    font-size: 0.75rem;\n    width: auto;\n    align-self: center;\n    padding: 0 0.85rem;\n  }\n}\n\n/* Page chrome: hide header / stamps / tabs — true fullscreen score pad */\n.cm-page--score-pad > .cm-head,\n.cm-page--score-pad > .cm-cam-status,\n.cm-page--score-pad > .cm-tables,\n.cm-page--score-pad > .cm-match-status,\n.cm-page--score-pad > .cm-actions,\n.cm-page--score-pad > .cm-dock,\n.cm-page--score-pad > .cm-stamps-wrap,\n.cm-page--score-pad > .cm-tagdock,\n.cm-page--score-pad > .cm-banner,\n.cm-page--score-pad > .cm-tabs {\n  display: none !important;\n}\n\n.cm-page--score-pad {\n  padding: env(safe-area-inset-top, 0px) 0\n    env(safe-area-inset-bottom, 0px);\n  gap: 0;\n  height: var(--lt-vvh, 100dvh);\n  max-height: var(--lt-vvh, 100dvh);\n}\n\nhtml.cm-immersive .cm-page--score-pad,\nhtml:fullscreen .cm-page--score-pad,\nhtml:-webkit-full-screen .cm-page--score-pad {\n  height: var(--lt-vvh, 100dvh);\n  max-height: var(--lt-vvh, 100dvh);\n}\n\n.cm-page--score-pad .cm-body {\n  flex: 1;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n.cm-page--score-pad .cm-panel {\n  flex: 1;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.cm-page--score-pad .cm-live {\n  margin: 0;\n  padding: 0;\n  gap: 0;\n  overflow: hidden;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.cm-page--score-pad .cm-scorepad {\n  flex: 1;\n  min-height: 0;\n  padding-left: 0.55rem;\n  padding-right: 0.55rem;\n  padding-bottom: max(0.35rem, env(safe-area-inset-bottom, 0px));\n}\n\n@media (orientation: landscape) and (max-height: 640px) {\n  .cm-page--score-pad .cm-scorepad {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n/* Portrait: score fills the card, empty ± row does not reserve space */\n@media (orientation: portrait) {\n  .cm-scorepad__card {\n    padding: 0.28rem 0.4rem 0.3rem;\n    gap: 0.06rem;\n  }\n\n  .cm-scorepad__score-wrap {\n    align-items: center;\n    justify-content: center;\n  }\n\n  .cm-scorepad__ops.is-empty {\n    display: none;\n  }\n}\n\n/* Short portrait phones: keep ± inside the cards; free room for tags */\n@media (orientation: portrait) and (max-height: 780px) {\n  .cm-scorepad {\n    gap: 0.3rem;\n    padding: 0.25rem 0.55rem 0.4rem;\n  }\n\n  .cm-scorepad__ops {\n    min-height: 2.15rem;\n  }\n\n  .cm-scorepad__plus,\n  .cm-scorepad__minus {\n    min-height: 2.15rem;\n    height: 2.15rem;\n  }\n\n  .cm-scorepad__undo,\n  .cm-scorepad__rally {\n    min-height: 2.2rem;\n  }\n\n  .cm-scorepad__dock {\n    gap: 0.28rem;\n  }\n\n  .cm-scorepad__dock .cm-outcome__btn {\n    min-height: 2.2rem;\n    padding: 0.16rem 0.08rem;\n  }\n\n  .cm-scorepad__dock .cm-outcome__text {\n    font-size: 0.56rem;\n  }\n\n  /* History steals the viewport under the tags — hide on short phones. */\n  .cm-scorepad__footer {\n    display: none;\n  }\n\n  .cm-scorepad__sheet-btn {\n    min-height: 2.35rem;\n  }\n}\n\n@media (orientation: portrait) and (max-height: 640px) {\n  .cm-scorepad__dock .cm-outcome__text {\n    display: none;\n  }\n\n  .cm-scorepad__dock .cm-outcome__mark {\n    font-size: 1.05rem;\n  }\n\n  .cm-scorepad__dock .cm-outcome__btn {\n    min-height: 2.05rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cm-scorepad__plus,\n  .cm-scorepad__minus,\n  .cm-scorepad__pts {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
